import React from 'react';

const before = [
  'Lead targeting built on spreadsheets and manual filters',
  'Caller IDs get spam-flagged with no rotation in place',
  'Missed callbacks because retry logic is handled manually',
  'Reporting lags hours behind live campaign data',
  "Too many tools that don't talk to each other",
  'Compliance forms built outside the agent workspace',
];

const after = [
  'SQL-powered targeting pulled straight from your data',
  'Dynamic CLI rotation eliminates spam flags at the root',
  'Automated retry engine fires on every call outcome',
  'Live dashboards with zero data lag across all campaigns',
  'One platform: dialling, forms, reporting, integrations',
  'Compliance capture embedded directly in the agent UI',
];

const Check = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0a9e8f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 1 }}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const Cross = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#484848" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0, marginTop: 2 }}>
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default function Comparison() {
  return (
    <section style={{ background: '#0a0a0a', borderTop: '1px solid rgba(10,158,143,0.1)', borderBottom: '1px solid rgba(10,158,143,0.1)', padding: '6rem 2.5rem' }}>
      <div style={{ maxWidth: 960, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <div style={tag}>// WHY TEAMS SWITCH</div>
          <h2 style={head}>Without DIALSPARK.<br /><span style={{ color: '#0a9e8f' }}>With DIALSPARK.</span></h2>
        </div>

        {/* Two-panel grid */}
        <div className="comparison-grid">

          {/* Before */}
          <div className="comparison-before" style={{ borderRadius: '12px 0 0 12px', border: '1px solid rgba(255,255,255,0.06)', borderRight: 'none', background: '#0a0a0a', padding: '2rem', display: 'flex', flexDirection: 'column', gap: 0 }}>
            <div style={{ fontSize: '0.68rem', color: '#7a7a7a', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em', marginBottom: '1.5rem', fontWeight: 600 }}>TRADITIONAL PLATFORMS</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
              {before.map((text, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <Cross />
                  <span style={{ fontSize: '0.84rem', color: '#707070', fontWeight: 400, lineHeight: 1.55 }}>{text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Divider with VS */}
          <div className="comparison-vs" style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 52, position: 'relative', zIndex: 2 }}>
            <div style={{ flex: 1, width: 1, background: 'linear-gradient(to bottom, transparent, rgba(10,158,143,0.2), transparent)' }} />
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#060606', border: '1px solid rgba(10,158,143,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ fontSize: '0.6rem', fontWeight: 700, color: '#077a6e', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.05em' }}>VS</span>
            </div>
            <div style={{ flex: 1, width: 1, background: 'linear-gradient(to bottom, transparent, rgba(10,158,143,0.2), transparent)' }} />
          </div>

          {/* After */}
          <div className="comparison-after" style={{ borderRadius: '0 12px 12px 0', border: '1px solid rgba(10,158,143,0.2)', borderLeft: '1px solid rgba(10,158,143,0.15)', background: 'linear-gradient(135deg, rgba(10,158,143,0.05) 0%, rgba(10,158,143,0.02) 100%)', padding: '2rem 2rem 2rem 2rem', display: 'flex', flexDirection: 'column', gap: 0, position: 'relative', overflow: 'hidden' }}>
            {/* Subtle glow in corner */}
            <div style={{ position: 'absolute', top: -60, right: -60, width: 200, height: 200, background: 'radial-gradient(circle, rgba(10,158,143,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />
            <div style={{ fontSize: '0.68rem', color: '#0a9e8f', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em', marginBottom: '1.5rem', fontWeight: 600, position: 'relative' }}>DIALSPARK</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem', position: 'relative' }}>
              {after.map((text, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <Check />
                  <span style={{ fontSize: '0.84rem', color: '#c0c0c0', fontWeight: 400, lineHeight: 1.55 }}>{text}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

const tag = { fontSize: '0.68rem', color: '#077a6e', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em', marginBottom: 14, display: 'block' };
const head = { fontSize: 'clamp(1.8rem, 3.5vw, 2.6rem)', fontWeight: 700, letterSpacing: '-0.035em', color: '#f0f0f0', lineHeight: 1.15 };
